import React from "react";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import "./css/KycClientSideFormPage.css";
import logoMyKyc from "../images/mykyc-logo-blue-800px.png";

function formatUploadedAt(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
}

export default function ClientUploadThanksPage() {
  const { state } = useLocation();
  const submittedAtText = formatUploadedAt(state?.submittedAt);

  return (
    <div className="KycClientSideFormPage docUploadThanksPage">
      <div className="kycPageContainer pb-4 docUploadThanksContainer">
        <div className="kycDesktopSubmitWrap">
          <motion.div
            className="kycDesktopSubmitHeader"
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.42, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="kycDesktopSubmitBadge">
              Thank you for uploading
            </div>

            <div className="kycDesktopSubmitOrb" aria-hidden="true">
              <motion.div
                className="kycDesktopSubmitOrbPulse"
                initial={{ scale: 0.78, opacity: 0.2 }}
                animate={{ scale: 1.16, opacity: 0.52 }}
                transition={{
                  duration: 1.6,
                  repeat: Infinity,
                  repeatType: "mirror",
                  ease: "easeInOut",
                }}
              />
              <motion.div
                className="kycDesktopSubmitOrbCore"
                initial={{ scale: 0.7, rotate: -16, opacity: 0 }}
                animate={{ scale: 1, rotate: 0, opacity: 1 }}
                transition={{
                  duration: 0.5,
                  delay: 0.08,
                  ease: [0.22, 1, 0.36, 1],
                }}
              >
                <i className="bi bi-check2" />
              </motion.div>
            </div>

            <motion.h1
              className="kycDesktopSubmitTitle"
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.38, delay: 0.14, ease: [0.22, 1, 0.36, 1] }}
            >
              Documents received
            </motion.h1>

            <motion.p
              className="kycDesktopSubmitLead"
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.38, delay: 0.22, ease: [0.22, 1, 0.36, 1] }}
            >
              Your documents have been securely delivered to our team.
            </motion.p>

            {submittedAtText ? (
              <motion.div
                className="kycDesktopSubmitTimestamp"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.34, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
              >
                Uploaded on {submittedAtText}
              </motion.div>
            ) : null}
          </motion.div>

          <motion.div
            className="kycDesktopSubmitNextCard"
            initial={{ opacity: 0, y: 22 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.42, delay: 0.24, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="kycDesktopSubmitNextTitle">What happens next</div>
            <div className="kycDesktopSubmitNextItem">
              <span className="kycDesktopSubmitNextDot" aria-hidden="true" />
              <span>
                The staff team will review your documents and revert if necessary.
              </span>
            </div>
            <div className="kycDesktopSubmitNextItem">
              <span className="kycDesktopSubmitNextDot" aria-hidden="true" />
              <span>
                You may be contacted if additional information is needed.
              </span>
            </div>
          </motion.div>
        </div>

        <motion.div
          className="docUploadFooterBrand"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.5, ease: "easeInOut" }}
        >
          <img src={logoMyKyc} alt="myKYC" className="docUploadFooterLogo" />
        </motion.div>
      </div>
    </div>
  );
}
